import { Component } from '@angular/core';

@Component({
  selector: 'temptik-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'temptik-page';
}
